import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "analytic-chart" }

import "./AnalyticChart.scss";
import {computed, ref, watch} from "vue";
import {useApiStore} from "@/stores/apiStore";
import moment, {Moment} from "moment";
import {useUserStore} from "@/stores/userStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyticChart',
  props: {
    mode: { default: '1m' }
  },
  setup(__props: any) {

let {api} = useApiStore();
let userStore = useUserStore();

let props = __props;

let values = ref<{ y : number, x : Moment }[]>([]);

watch(() => props.mode, async (v) => {

	let rows = await api.getTradeAnalytic(v);

	values.value = rows.map(row => {
		return {
			y : (row.value - 1) * 100,
			x : moment(row.created_at)
		}
	});

	let old = moment(userStore.me!.created_at);
	while(values.value.length < 2){

		values.value.unshift({
			y : 0,
			x : old.clone()
		});

		old.subtract(1, 'days');

	}

}, {immediate : true});

let series = computed(() => {

	return [{
		name: 'Change',
		data: values.value
	}];

})

let options = computed(() => {

	let min = values.value.length >= 2
		? values.value.reduce((a, b) => a.y < b.y ? a : b).y
		: values.value.length
			? values.value[0].y
			: 0;

	min = Math.min(0, min);

	return {
		chart: {
			background: 'transparent',
			toolbar: { show: false },
			zoom: { enabled: false }
		},
		stroke: {
			curve: 'straight',
			width: 2
		},
		colors: ['#3CFF9E'],
		fill: {
			type: 'gradient',
			gradient: {
				shade: 'dark',
				opacityFrom: 0.45,
				opacityTo: 0.05,
				stops: [0, 100]
			}
		},
		grid: {
			borderColor: 'rgba(255,255,255,0.08)',
			strokeDashArray: 0,
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		},
		dataLabels: { enabled: false },
		xaxis: {
			labels: { show: false },
			axisBorder: { show: false },
			axisTicks: { show: false },
			type: 'datetime',
		},
		yaxis: {
			min : min,
			labels: {
				formatter: (v: number) => v.toFixed(2) + '%',
				style: { colors: '#3ACA7B', fontSize: 8 }
			}
		},
		tooltip: {
			theme: 'dark',
			y: {
				formatter: (v: number) => v.toFixed(2) + '%'
			},
			x : {
				formatter: (v: Moment) => moment(v).format('YYYY-MM-DD HH:mm')
			}
		},
		theme: {
			mode: 'dark'
		}
	}

})

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_apexchart, {
      type: "area",
      height: "250",
      series: _unref(series),
      options: _unref(options)
    }, null, 8, ["series", "options"])
  ]))
}
}

})